import * as React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as MenuSVG } from "../../icons/menu.svg";
import type { Theme } from "../../theme";

type Props = {
  onClick: () => void;
};

const menuButtonStyle = ({ gridUnit, iconSize, colors }: Theme) => ({
  position: "fixed" as const,
  top: `${gridUnit * 5}px`,
  left: `${gridUnit * 5}px`,
  zIndex: 998,
  background: colors.grey95,
  border: `2px solid ${colors.grey4}`,
  borderRadius: `${gridUnit}px`,
  width: iconSize,
  height: iconSize,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
  transition: "all 0.2s ease",
  ":hover": {
    backgroundColor: "#f5f5f5",
    transform: "scale(1.05)",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)"
  },
  ":active": {
    transform: "scale(0.95)"
  },
  svg: {
    fill: colors.grey8,
    stroke: colors.grey0
  }
});

const MenuButton = ({ onClick }: Props): React.ReactNode => {
  const { t } = useTranslation();
  return (
    <button css={menuButtonStyle} onClick={onClick} aria-label={t("menuButton.openMenu")} type="button">
      <MenuSVG />
    </button>
  );
};

export default MenuButton;
